import React, { Fragment } from 'react';
import { TopBar } from "./TopBar";
import Hidden from "@material-ui/core/Hidden";
import Drawer from "@material-ui/core/Drawer";
import { MenuDrawer } from "./MenuDrawer";
import { createStyles, makeStyles } from "@material-ui/core/styles";
export var drawerWidth = 240;
var useStyles = makeStyles(function (theme) {
    var _a, _b;
    return createStyles({
        root: {
            display: 'flex',
        },
        grow: {
            flexGrow: 1,
        },
        drawer: (_a = {},
            _a[theme.breakpoints.up('sm')] = {
                width: drawerWidth,
                flexShrink: 0,
            },
            _a),
        drawerPaper: {
            width: drawerWidth,
        },
        content: (_b = {},
            _b[theme.breakpoints.up('sm')] = {
                marginLeft: drawerWidth,
                flexShrink: 0,
            },
            _b.marginTop = 80,
            _b),
    });
});
export function Frame(_a) {
    var children = _a.children, logout = _a.logout, userInfo = _a.userInfo, title = _a.title, routerLinks = _a.routerLinks, logoArea = _a.logoArea;
    var classes = useStyles();
    var _b = React.useState(false), mobileOpen = _b[0], setMobileOpen = _b[1];
    function handleDrawerToggle() {
        setMobileOpen(!mobileOpen);
    }
    return (React.createElement(Fragment, null,
        React.createElement(TopBar, { title: title, toggleDrawer: handleDrawerToggle, userInfo: userInfo }),
        React.createElement("div", { className: classes.content }, children),
        React.createElement("nav", { className: classes.drawer },
            React.createElement(Hidden, { smUp: true, implementation: "css" },
                React.createElement(Drawer, { variant: "temporary", open: mobileOpen, onClose: handleDrawerToggle, classes: {
                        paper: classes.drawerPaper,
                    }, ModalProps: {
                        keepMounted: true,
                    } },
                    React.createElement(MenuDrawer, { logout: logout }))),
            React.createElement(Hidden, { xsDown: true, implementation: "css" },
                React.createElement(Drawer, { classes: {
                        paper: classes.drawerPaper,
                    }, variant: "permanent", open: true },
                    React.createElement(MenuDrawer, { logout: logout, routerLinks: routerLinks, logoArea: logoArea }))))));
}
//# sourceMappingURL=Frame.js.map